import { Table } from "antd";
import { get } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { formatNumber } from "../../../../../utils/utilities";

export default function TableLegend(props) {
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const { t } = useTranslation();

  const columns = [
    {
      dataIndex: "title",
      width: 150,
      key: "username",
    },
    {
      title: t("projectsManagement.riskAnalysis.legendTable.initial"),
      dataIndex: "initial",
      key: "initial",
      className: "table-value-right-alsoheader",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
    {
      title: t("projectsManagement.riskAnalysis.legendTable.current"),
      dataIndex: "current",
      key: "initial",
      className: "table-value-right-alsoheader",
      render: (amount) => formatNumber({ value: amount, suffix: "EUR", lang: currentLanguage, decimalScale: 0 }),
    },
  ];

  return <Table bordered dataSource={props.data} columns={columns} size="small" pagination={false} />;
}
